import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import ContratoService from '../../../services/contrato'
import Contrato from './contrato';
import Moment from 'moment';


const ListarContratos = () => {

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    const [contratos, setContratos] = useState([]);
    const [vazio, setVazio] = useState(false);




    async function fetchContratosIn() {
        const response = await ContratoService.chamamento();
        if (response.data.length >= 1) {
            setContratos(response.data)
            setVazio(false)
        } else {
            setContratos([])
            setVazio(true)
        }
    }


    useEffect(() => {
        fetchContratosIn();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setContratos={setContratos}
                    setVazio={setVazio}
                    fetchContratosIn={fetchContratosIn}
                    contratos={contratos}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row xs={1}>
                        {contratos.map((contrato, index) =>
                            <Contrato
                                contrato={contrato}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarContratos;